import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getSectionsByBookId = (bookId) => {
    return axios.get(`/api/sbBook/section/${bookId}/list`, { headers: authHeaderJson() } );
};
const getSectionsByPartyIdPartyMemberId = (partyId, partyMemberId) => {
    return axios.get(`/api/sbBook/partysectionmember/${partyId}/${partyMemberId}/list`, { headers: authHeaderJson() } );
};
const getSectionsByPartyId_Old = (partyId) => {
    return axios.get(`/api/sbBook/partysection/${partyId}/list`, { headers: authHeaderJson() } );
};
const getMessageTopics = () => {
    return axios.get(`/api/sbMessage/messageTopic/list`, { headers: authHeaderJson() } );
};


const getMessageTemplateTopic = (topicId) => {
    return axios.get(`/api/sbMessage/messageTopic/${topicId}/get`, { headers: authHeaderJson() } );
};



const getSectionPartyFullsByBookId = (bookId, sectionId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/sbBook/sectionpartyfull/${bookId}/${sectionId}/list`, { headers: authHeaderJson() } );
};
const createSectionsByBookId = (bookId, objSectionList) => {
    return axios.put(`/api/sbBook/section/${bookId}/list`, objSectionList, { headers: authHeaderJson() } );
};
const deleteSectionById = (sectionId) => {
    return axios.delete(`/api/SbBook/section/${sectionId}`, { headers: authHeaderJson() });
};
const getSectionStructureType = (bookId) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/sbBook/book/sectionstructure/${bookId}/list`, { headers: authHeaderJson() } );
};
const getSectionStructureConcept = (id) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/sbBook/section/structureconcept/${id}/list`, { headers: authHeaderJson() } );
};
const getSectionClassList = () => {
    return axios.get(`/api/sbBook/section/class/list`, { headers: authHeaderJson() } );
};


export {
    createSectionsByBookId,
    getSectionsByBookId,
    getMessageTopics,
    getMessageTemplateTopic,
    getSectionsByPartyIdPartyMemberId,
    getSectionPartyFullsByBookId,
    deleteSectionById,
    getSectionStructureType,
    getSectionStructureConcept,
    getSectionClassList
}